// store/reducers/user.jsx

import { userActionTypes } from "../actions/actionTypes";

const initialState = {
  loggedIn: false,
  loading: false,
  error: false,
  errorMessage: "",
  logInError: false,
  signupError: false,
  qb_connected: false,
  name: "",
  email: "",
  picture: "",
  token: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case userActionTypes.LOGIN_START:
      return {
        ...state,
        loading: true,
        logInError: false,
        signupError: false,
        error: false,
        errorMessage: "",
        errorCode: null,
      };

    case userActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        loggedIn: true,
        error: false,
        errorMessage: "",
        logInError: false,
        name: action.name,
        email: action.email,
        role: action.role,
        picture: action.picture,
        qb_connected: action.qb_company_id && action.qb_access_token ? true : false,
        token: action.token,
        isGuest: false,
      };

    case userActionTypes.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        loggedIn: false,
        error: true,
        errorMessage: action.errorMessage,
        logInError: true,
        name: "",
        email: "",
        picture: "",
        token: "",
      };

    case userActionTypes.LOGIN_GUEST_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        loading: false,
        error: false,
        errorMessage: "",
        name: action.name,
        email: action.email,
        role: action.role,
        picture: action.picture,
        token: action.token,
        isGuest: action.isGuest,
        qb_company_id: action.qb_company_id,
        qb_access_token: action.qb_access_token,
      };

    case userActionTypes.LOGOUT:
      return {
        ...state,
        loggedIn: false,
        email: "",
        name: "",
        role: "",
        picture: "",
        token: "",
        qb_connected: false,
        error: false,
        errorMessage: "",
        logInError: false,
        isGuest: false,
      };

    case userActionTypes.SET_QB_CONNECTED:
      return {
        ...state,
        qb_connected: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;